import React from "react";

import styles from "./WeatherlyIcon.module.scss";

import rainbowSvg from "../../assets/03_svgs/rainbow.svg";

function WeatherlyIcon() {
  return (
    <img
      className={styles["container"]}
      src={rainbowSvg}
      alt="Weatherly Icon"
    />
  );
}

export default WeatherlyIcon;
